// import ProjectsList from './Netlify';
import LinkList from './Projects';

function App() {
  return (
    <div>
      <LinkList/>
      {/* <ProjectsList/> */}
    </div>
  );
}

export default App;
